import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

declare global {
  interface Window {
    __BOOT_ERR__?: { type: string; message: string; stack?: string };
  }
}

window.__BOOT_ERR__ = undefined;

window.addEventListener("error", (e: ErrorEvent | Event) => {
  let message = "Unknown window error";
  let stack = "";

  if (e instanceof ErrorEvent) {
    message = e.message || message;
    stack = e.error?.stack || "";
  } else {
    // Fallback for non-ErrorEvent (e.g. resource load errors)
    const target = e.target as HTMLElement;
    if (target) {
      const src = (target as any).src || (target as any).href;
      if (src) message = `Resource loading failed: ${src}`;
    }
  }

  window.__BOOT_ERR__ = {
    type: "error",
    message,
    stack,
  };
  
  // Improve console logging to show the actual error/message instead of the Event object
  console.error("[window.error]", message, e instanceof ErrorEvent ? e.error : e);
  
  // If app hasn't mounted yet, show error on screen
  const root = document.getElementById("root");
  if (root && (!root.innerHTML || root.innerHTML.trim() === "")) {
     document.body.innerHTML = `
       <div style="background:#111; color:#ff5a6a; padding:20px; font-family:monospace; white-space:pre-wrap;">
         <h2 style="color:#fff">Application Startup Error</h2>
         <p>${message}</p>
         <div style="opacity:0.7; font-size:12px; margin-top:10px;">${stack}</div>
       </div>
     `;
  }
});

window.addEventListener("unhandledrejection", (e) => {
  const reason: any = (e as any).reason;
  const message = reason?.message || String(reason) || "Unhandled rejection";
  const stack = reason?.stack;

  window.__BOOT_ERR__ = {
    type: "unhandledrejection",
    message,
    stack,
  };
  console.error("[unhandledrejection]", reason);
});

console.log("BOOT_OK");

const rootEl = document.getElementById("root");
if (!rootEl) {
  document.body.innerHTML =
    '<pre style="padding:16px;font-family:system-ui;background:#fff;color:#111">Missing #root</pre>';
} else {
  createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}